export default __webpack_public_path__ + "static/media/icon-coin-ena.77db859f.svg";